import { cn } from '@/lib/utils'
import { useAppSelector } from '@/store'
import { FC, ReactNode } from 'react'
import { Footer } from './Footer'
import { Header } from './Header'

interface PageLayoutProps {
  children: ReactNode
  showHeader?: boolean
  showFooter?: boolean
  className?: string
  authPage?: boolean
}

export const PageLayout: FC<PageLayoutProps> = ({
  children,
  showHeader = true,
  showFooter = true,
  className = '',
  authPage = false,
}) => {
  const { isSidebarCollapsed } = useAppSelector((s) => s.app)

  return (
    <div className="flex flex-col min-h-screen">
      {showHeader && <Header authPage={authPage} />}

      <div
        className={cn(
          'flex-1 pt-24 transition-all duration-300',
          isSidebarCollapsed
            ? 'px-5 ps-5'
            : !authPage
            ? 'ps-[calc(375px+40px)] pe-5'
            : 'ps-5 pe-5',
          className,
        )}
      >
        {children}
      </div>

      {showFooter && <Footer />}
    </div>
  )
}

export default PageLayout
